module.exports = __webpack_public_path__ + "media/images/admin2/AdminAnnouncement__a-49341741041d756c33ac4db4d4cfd3e4.svg";